import React, { useEffect, useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';

import '../../styles.css';
import TestsDraggableList from './TestsDraggableList';

const TestsDroppableBox = ({
  tests,
  boxStyle = {},
  mode = 'view',
  disableActions,
}) => {
  const [enabled, setEnabled] = useState(false);
  /**
   * This is used to render the Droppable elements after an animation frame,
   * because react-beautiful-dnd library has some issues with React 18 compatibility.
   */
  useEffect(() => {
    const animation = window.requestAnimationFrame(() => setEnabled(true));

    return () => {
      window.cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <Droppable
      droppableId={`tests-droppable`}
      type="tests"
      isDropDisabled={disableActions}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          style={boxStyle}
        >
          <TestsDraggableList
            snapshot={snapshot}
            isInDragAction={
              snapshot.isDraggingOver || snapshot.draggingFromThisWith
            }
            mode={mode}
            disableActions={disableActions}
            tests={tests}
          />
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default TestsDroppableBox;
